export default __webpack_public_path__ + "img/ef26c36d5b598b9f1e28c37b33146850.svg";